// extracted by mini-css-extract-plugin
export default {"userMessage":"Message_userMessage__Dhgyo","assistantMessage":"Message_assistantMessage__JNxjv"};